module.exports = __webpack_public_path__ + "static/media/mission_statement_test.b4785fdb.jpg";